export const baseURL = "https://admin.pokevo.jp/";
// export const baseURL = "http://192.168.29.35:5038/";     
export const key = "uLA>-M&H7zX:Z[`Lgi&4~V`AVSm[TG";
